import { combineReducers } from 'redux';

import employee from './employee';

export default combineReducers({
  employee,
});
